type StorageType = 'local' | 'session';

const getStorage = (type: StorageType): Storage => {
  return type === 'local' ? localStorage : sessionStorage;
};

export const storageUtil = {
  setItem: (key: string, value: unknown, type: StorageType = 'session') => {
    try {
      const storage = getStorage(type);
      storage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Could not save ${key}`, e);
    }
  },

  getItem: <T = unknown>(
    key: string,
    type: StorageType = 'session',
  ): T | null => {
    try {
      const storage = getStorage(type);
      const serializedValue = storage.getItem(key);
      return serializedValue ? JSON.parse(serializedValue) : null;
    } catch (e) {
      console.error(`Could not load ${key}`, e);
      return null;
    }
  },

  removeItem: (key: string, type: StorageType = 'session') => {
    try {
      const storage = getStorage(type);
      storage.removeItem(key);
    } catch (e) {
      console.error(`Could not remove ${key}`, e);
    }
  },
};
